import Links from '@/shared/constants/navegacao';
import { Link } from 'react-router-dom';
import { ReadLotacaoDto } from '@/api.types';
import { DataAmigavel } from '@/shared/utils/datas';
import { TipoLotacaoEstagioList, TipoLotacaoList } from '@/shared/constants/enumlist';

const TIPO_LOTACAO_LIST = TipoLotacaoList.concat(TipoLotacaoEstagioList);

type LotacoesPerfilTableProps = {
  lotacoes: ReadLotacaoDto[];
  emptyMessage: string;
  /** Inclui tipos de lotação de estágio (útil no perfil estagiário). */
  incluirTiposEstagio?: boolean;
};

export function LotacoesPerfilTable({
  lotacoes,
  emptyMessage,
  incluirTiposEstagio = false,
}: LotacoesPerfilTableProps) {
  const tipos = incluirTiposEstagio ? TIPO_LOTACAO_LIST : TipoLotacaoList;

  if (lotacoes.length === 0) {
    return <p className="text-muted small mb-0 py-1">{emptyMessage}</p>;
  }

  return (
    <table className="table table-sm table-bordered table-hover table-striped mb-0">
      <thead>
        <tr>
          <th>Tipo</th>
          <th className="text-center">Início</th>
          <th className="text-center">Término</th>
          <th>Local</th>
        </tr>
      </thead>
      <tbody>
        {lotacoes.map((lotacao, index) => {
          const local = lotacao.defensoria?.nome || lotacao.nucleo?.nome || lotacao.setor?.nome || '-';
          return (
            <tr key={lotacao.id ?? index}>
              <td>{tipos.find((a) => a.value === lotacao.tipo)?.name ?? '-'}</td>
              <td className="text-center">
                {lotacao.data_inicial ? DataAmigavel(lotacao.data_inicial) : '-'}
              </td>
              <td className="text-center">
                {lotacao.data_final ? DataAmigavel(lotacao.data_final) : '-'}
              </td>
              <td>
                {lotacao.id ? (
                  <Link to={`${Links.Vinculos_Editar}/${lotacao.id}`} title="Editar lotação">
                    {local}
                  </Link>
                ) : (
                  local
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
